import { Injectable } from '@angular/core'; 
import { HttpClient, HttpHeaders} from  "@angular/common/http";
import { constVariables } from "../../constants/ConstantPath";
@Injectable({
  providedIn: 'root'
})
export class HomeService {
  	constructor(private http: HttpClient) { }
  	getFeaturedImages() {
		let promise = new Promise((resolve, reject) => {
		    const url = constVariables.apiUrl +"frontend/Home/get_featured";
		    this.http.get<any[]>(url).subscribe((res: any) => {
		    	resolve(res);
		    });
		});
		return promise;
	}

	

}
